(function(utils) {
	utils.dokpotpisSGridAddRow = dokpotpisSGridAddRow;
	utils.rowAddSurjesavatelj = rowAddSurjesavatelj;
    utils.rowObojiCell = rowObojiCell;
    utils.rowOdradiPravoNa = rowOdradiPravoNa;
	utils.rowOdradiSadrzajEmailPoruke = rowOdradiSadrzajEmailPoruke;
	utils.rowObradiOznaceneSurjes = rowObradiOznaceneSurjes;
	utils.odradiDohvatiDatoteku = odradiDohvatiDatoteku;
	utils.dokKnjPrikaziPanele = dokKnjPrikaziPanele;
	utils.dokKnjPrikaziElementeNaPanelu = dokKnjPrikaziElementeNaPanelu;

	
	utils.UbaciOpaskaUMemo = function( $button, $memo){
	    var linkR = kontorouter.getModulPath("opaska/pregled/UMD");
        $button.click(function(){ 
            konto.dialogs.sifarnik({
                template: linkR,
                odabir: function(data){
                    if (data){
                        vecUpisano = $memo.val();
                        vecUpisano += data.TEKST2;
                        $memo.val(vecUpisano); 
                    }
                }
            }); 
        });
	};
	
	function dokpotpisSGridAddRow(grid, data, rowEl, sifarnik) {
		    var column = grid.getCell(rowEl, 'REDOSLJED');                        
            if ((data.NIJEPOTPIS == 1) || (data.NIJEPOTPIS == 2) || (data.NIJEPOTPIS == 3)){
                if (data.OPCIJE.indexOf('j') != -1) {
                   column.html("<div>Z" + column.html());
                    sifarnik.applayRowCSS('COLOR=10789024;FSTYLE=italic;', rowEl);
                   }
                else 
                   column.html("OBRADA");        
            }
            else if (data.STATUS == 2) {
                column.html("<i class='fas fa-check' title='Odobreno'></i> " + column.html());                            
                column.css("background-color", "#C2F5A2");                            
            }
            else if (data.STATUS == 1) {
                column.css("background-color", "#F5D4D7");                           
                column.html("<i class='fas fa-times' title='Odbijeno'></i> " + column.html());                                
            }
            else if (data.STATUS == -1) {
                column.css("background-color", "#F5D4D7");                           
                column.html("<i class='fas fa-sync ' title='Vraćeno'></i> " + column.html());                                
            }
            else {
                var danas = new Date();
                var columnRok = grid.getCell(rowEl, 'ROKDATUM');   
                lsPom = "";
                if (data.OPCIJE.indexOf('j') != -1) {
                    lsPom = "Z";
                    }
                if (data.ROKDATUM) {
                    if (KUtils.formatDate(danas) == KUtils.formatDate(data.ROKDATUM)) 
                        column.html("<i class='fas fa-circle' title='Rok je danas( datum roka: " + columnRok.html() + ")' style='color:#FFBE00'></i> " + lsPom + column.html()); 
                    else if (data.ROKDATUM < danas) 
                        column.html("<i class='fas fa-circle' title='Prošao rok (datum roka: " + columnRok.html() + ")' style='color:red'></i> " + lsPom + column.html());
                    else 
                        column.html("<i class='fas fa-circle' title='Rok nije prošao (datum roka: " + columnRok.html() + ")' style='color:#00994C'></i> " + lsPom + column.html());
                }
           }
	}
               
    function rowObojiCell(sif, rowEl, aCell, prop, propVrij) {
        if (aCell) {
            for (var i = 0; i < aCell.length; ++i) {
				var column = sif.getCell(rowEl, aCell[i]);
				if (column) {
					column.css(prop, propVrij);
				}
            }
        }
    }
               
	function rowAddSurjesavatelj(grid, data, rowEl){
    	if (data.SURJESAVATELJ) {
		    if ((data.SURJESAVATELJ == -21) || (data.SURJESAVATELJ == -22) || 
		    	(data.SURJESAVATELJ == 21) || (data.SURJESAVATELJ == 22) || 
		    	(data.SURJESAVATELJ == -1) || (data.SURJESAVATELJ == -2) ||
		    	(data.SURJESAVATELJ == -111) || (data.SURJESAVATELJ == -112) 
		    	) {
				rowObojiCell(grid, rowEl, ['RADNJA'], "color", "#959191"); // sivo
			   }
			else {
				rowObojiCell(grid, rowEl, ['SURJRADNJA','RADNJA'], "color", "#0592bd"); // ljubičasta
			}
		    if ((data.SURJESAVATELJ == 1) || (data.SURJESAVATELJ == 2)) {
				rowObojiCell(grid, rowEl, ['SURJRADNJA','RADNJA','UJPRIMAOZNAKA','UJPRIMANAZIV','VRNAMJENANAZIV','PORUKA','VRIJEMEDODJELESALJE'], "font-style", "italic");
				rowObojiCell(grid, rowEl, ['SURJRADNJA','RADNJA','UJPRIMAOZNAKA','UJPRIMANAZIV','VRNAMJENANAZIV','PORUKA','VRIJEMEDODJELESALJE'], "color", "#226cf1");
		    }
		    if ((data.SURJESAVATELJ == 11) || (data.SURJESAVATELJ == 12)) {
				rowObojiCell(grid, rowEl, ['RADNJA'], "font-weight", "bold");
		    }
		}
		else if (data.VRIJEMEDODJELESALJE) {
			rowObojiCell(grid, rowEl, ['RADNJA','UJPRIMAOZNAKA','UJPRIMANAZIV','VRNAMJENANAZIV','PORUKA','VRIJEMEDODJELESALJE','DOSTAVNICAS'], "color", "#226cf1"); //plavo 
			rowObojiCell(grid, rowEl, ['RADNJA','UJPRIMAOZNAKA','UJPRIMANAZIV','VRNAMJENANAZIV','PORUKA','VRIJEMEDODJELESALJE','DOSTAVNICAS'], "font-style", "italic"); 
			
		}
		else if (data.UJPOTPISOZNAKA) {
			rowObojiCell(grid, rowEl, ['UJPOTPISOZNAKA','UJPOTPISNAZIV','ZOSOBA','ZOSOBANAZIV'], "color", "#226cf1"); //plavo 
			rowObojiCell(grid, rowEl, ['UJPRIMAOZNAKA','UJPOTPISNAZIV','ZOSOBA','ZOSOBANAZIV'], "font-style", "italic"); 
		}
	}
	
	function odradiDohvatiDatoteku(data, lbModal){
		var defX = $.Deferred();
		var modalVrsta = 0; //1=pdf, mp4; 2=png,jpg,jpeg; 3=datoteka na url (web servis?); 4=datoteka na putanji
		var liDatoteka = data.DATOTEKA? data.DATOTEKA : data.FDatoteka;
		var liDokument = 0;
		var lsNaziv = data.NAZIV? data.NAZIV : data.FNaziv;
		var liPotpisUDat = 0;
		var datotekaOpcije = '';
		var fileName = '';

		if (liDatoteka != 0) {
			if (data.DOKUMENT)
				liDokument = data.DOKUMENT;
			else if (data.FDokument)
				liDokument = data.FDokument;

			fileName = data.FILENAME? data.FILENAME.toLowerCase() : data.FFileName.toLowerCase();
			if (data.POTPISUDAT)
				liPotpisUDat = data.POTPISUDAT;
			else if (data.FPotpisUDat)
				liPotpisUDat = data.FPotpisUDat;
			lsNaziv = data.NAZIV? data.NAZIV : data.FNaziv;
			
			if (data.DATOPCIJE) {datotekaOpcije = data.DATOPCIJE;}
			else if (data.FOpcije) {datotekaOpcije = data.FOpcije;}

	        if (datotekaOpcije.indexOf('H') != -1){ //DatotekaNaUrl
	        	modalVrsta = 3;
	           }
	        else if (datotekaOpcije.indexOf('U') != -1){ //DatotekaNaPutanji
	        	modalVrsta = 4;
	           }
			else if ((fileName.indexOf('.pdf') > -1) || (fileName.indexOf('.mp4') > -1) ){
				modalVrsta = 1;
                }
	        else if ((fileName.indexOf('.png') > -1) || (fileName.indexOf('.jpg') > -1) || (fileName.indexOf('.jpeg') > -1) || (fileName.indexOf('.bmp') > -1)) {
				modalVrsta = 2;
	        }
       	}

		if (liDatoteka == 0) {//(!data.DATOTEKA) {
			defX.resolve(0);	
		}
        else if (liPotpisUDat == 0) {//(!data.POTPISUDAT) {
        	defX.resolve(liDatoteka);
        }
        else {
			konto.uz.api.DozvoliPrikazDatotekeSCert(liDatoteka, liDokument).then(function(rez){
					if (rez.pitanje) {					
						konto.dialogs.upit({
							title: "Upozorenje",
							content: rez.pitanje,
							potvrdi: function () {
								defX.resolve(rez.datoteka)
							},
							odustani: function () {
								if (rez.dozvoliJerImaPravo) {
									defX.resolve(liDatoteka);	
								} 
								else {
									// ništa
								}
							}
						});
					}
					else {
						defX.resolve(liDatoteka);
					}
				});
        }
        
        defX.then(function(kojaDat){
        	if (kojaDat != 0) {
	        	if ((modalVrsta == 3) || (modalVrsta == 4)) {
	        		window.open(fileName, '_blank');	
	        	}
	        	else if (lbModal && (modalVrsta == 1)) {
	                var url = kontorouter.getModulPath("datoteka/dohvati/" + kojaDat + "/" + liDokument);
	                if ( !KUtils.getEdgeOrIE() ){
	                    url += '/?viewBrowser';
	                } 
	                var prikazi = "<object data='" + url + "' type='application/pdf' width='100%' height='100%'></object>";
                    konto.dialogs.pretraga({
						title: "Pregled datoteke: " + kojaDat + ' ' + lsNaziv,
						width:'80%',
						height: '95vh',
						content: prikazi,
						buttons: {
							"Zatvori": {
								isPrimary: true,
								click: function () {
									this.close();
								}
							}
						}
					});	
	        	}
	        	else if (lbModal && (modalVrsta == 2)) {
	                konto.uz.api.DohvatiDatotekuBase64(kojaDat, liDokument).then(function(kontoStream){
                        var src = 'data:image/png;base64,' + kontoStream;                           
                        var prikazi = "<img src='" + src + "' type='image/png;base64' width='100%' height='100%' style='object-fit:contain;'></img>";

		                    konto.dialogs.pretraga({
								title: "Pregled datoteke: " + kojaDat + ' ' + lsNaziv,
								width:'80%',
								height: '95vh',
								content: prikazi,
								buttons: {
									"Zatvori": {
										isPrimary: true,
										click: function () {
											this.close();
										}
									}
								}
							});	
                    });    
	        	}
	        	else 
	        		{kontorouter.gotoLocation("datoteka/dohvati/" + kojaDat + "/" + liDokument);}
        	}
        	else {
            	konto.dialogs.upozori({
            		width: 600,
                	content: "Nije moguće odrediti datoteku za prikaz."
                });  							
        	}		
		});
        
	}



	function rowOdradiPravoNa(grid, data, kojePravo){
		var sifraUJ = 0;	
		var zaPoruku = '';	
		if (kojePravo == 'pravoSlanje'){
			zaPoruku = 'UJ dokum.mj.';
            if (data.USTROJDOKUMMJ) {  
            	sifraUJ = data.USTROJDOKUMMJ;                                                                   
                //lsLink = "nadleznost/pregledPreuzmi/" + data.USTROJDOKUMMJ;
                lsLink = "nadleznost/pregledPravaUJ/0/" + data.USTROJDOKUMMJ + "/preuzmi";
                $.dialog({
                    title: "Popis osoba sa nadležnostima za slanje sa UJ " + data.USTROJDOKUMMJ + ' - ' + data.UJDOKUMOZNAKA + ' ' + data.UJDOKUMNAZIV,
                    template: kontorouter.getModulPath(lsLink)
                });
         	}
		}
		else if (kojePravo == 'pravoPreuzimanje'){//UJ primatelja
			zaPoruku = 'UJ primatelja';
            if (data.USTROJPRIMA) {                                                                     
            	sifraUJ = data.USTROJPRIMA;                                                                   
                //lsLink = "nadleznost/pregledPreuzmi/" + data.USTROJPRIMA;
                lsLink = "nadleznost/pregledPravaUJ/0/" + data.USTROJPRIMA + "/preuzmi";
                $.dialog({
                    title: "Popis osoba sa nadležnostima za preuzimanje na UJ " + data.USTROJPRIMA + ' - ' + data.UJPRIMAOZNAKA + ' ' + data.UJPRIMANAZIV,
                    template: kontorouter.getModulPath(lsLink)
                });
         	}
		}
		else if (kojePravo == 'pravoUnos'){// pravo unosa
			zaPoruku = 'UJ dokum.mj.';
            if (data.USTROJDOKUMMJ) {                                                                     
            	sifraUJ = data.USTROJPRIMA;                                                                   
                //lsLink = "nadleznost/pregledUnos/" + data.USTROJDOKUMMJ;
                lsLink = "nadleznost/pregledPravaUJ/0/" + data.USTROJDOKUMMJ + "/unos";
                $.dialog({
                    title: "Popis osoba sa nadležnostima za unos na dokumentacijsko mjesto UJ " + data.USTROJDOKUMMJ + ' - ' + data.UJDOKUMOZNAKA + ' ' + data.UJDOKUMNAZIV,
                    template: kontorouter.getModulPath(lsLink)
                });
         	}
		}
		else if (kojePravo == 'pravoPotpis'){// pravo potpis
			zaPoruku = 'UJ potpisnika';
            if (data.USTROJ) {                                                                     
            	sifraUJ = data.USTROJ;                                                                   
                //lsLink = "nadleznost/pregledUnos/" + data.USTROJDOKUMMJ;
                lsLink = "nadleznost/pregledPravaUJ/0/" + data.USTROJ + "/potpis";
                $.dialog({
                    title: "Popis osoba sa nadležnostima za potpisivanje u UJ " + data.USTROJ + ' - ' + data.USTROJOZNAKA + ' ' + data.USTROJNAZIV,
                    template: kontorouter.getModulPath(lsLink)
                });
         	}
		}
		else if (kojePravo == 'pravoUnosKP'){// pravo unosa
			zaPoruku = 'klase';
            if (data.KLASAPLAN) {                                                                     
            	sifraUJ = data.KLASAPLAN;                                                                   
                lsLink = "nadleznost/pregledPravaKP/0/" + data.KLASAPLAN;
                $.dialog({
                    title: "Popis osoba sa nadležnostima za unos na šifru klase " + data.KLASAPLAN,
                    template: kontorouter.getModulPath(lsLink)
                });
         	}
		}
     	if (sifraUJ == 0) {
            $.dialogGreska({
                title: "Upozorenje",
                content: "Nije zadana šifra " + zaPoruku
            });
     	}
	}	
	
	function rowOdradiSadrzajEmailPoruke(grid, data, radnja){
		var ima = 0;
		if (radnja == 'sadrzajPoruke'){
	        if ((data.DOSTAVNICASINAZIVISPIS) || (data.INAZIVISPIS)) {
	        	ima = 1;
	        	if (data.DOSTAVNICASINAZIVISPIS) 
	        		tekst = data.DOSTAVNICASINAZIVISPIS
	        	else 
	        		tekst = data.INAZIVISPIS;
                $.dialog({
                    content: tekst,
                    title: "Sadržaj poslane e-mail poruke",
                });
               }
		}
		else if (radnja == 'sadrzajPorukeDetaljno'){
	        if ((data.DOSTAVNICASINAZIVISPIS) || (data.INAZIVISPIS)) {
	        	ima = 1;
	            // info o predmetu
	            konto.uz.api.DostavnicaSEmailInfo(data.DOSTAVNICAS)
	                .then(function (data) {
	                	var lsInfo = ''
	                	if (data && data.EmailZOsobaSalje) {
							lsInfo = lsInfo + data.EmailZOsobaSalje + '<BR>';
							lsInfo = lsInfo + data.EmailSalje + '<BR>';
							lsInfo = lsInfo + data.EmailPopisDatoteka + '<BR>';
							lsInfo = lsInfo + data.EmailOpaska + '<BR><BR>';
							lsInfo = lsInfo + data.EmailSubjekt + '<BR><BR>';
							lsInfo = lsInfo + data.EmailBody;
							}
						else {
							lsInfo = 'Nema podataka.'
						}
                    $.dialog({
                        content: lsInfo,
                        title: "Svi detalji o poslanoj e-mail poruci",
                    });
	            });
	            }
		}
     	if (ima == 0) {
            $.dialog({
                content: "Nema se ništa za prikazati",
                title: "Upozorenje",
            });
     	}
	}		
                
	function rowObradiOznaceneSurjes(grid, data, tablica, radnja){
        if (data.length == 0) {
            $.dialogGreska({
                title: "Upozorenje",
                content: "Nije označena niti jedna stavka"
            });
            return;
     	}
     	else if ((radnja == 'odbij') && (data.length != 1)) {
            $.dialogGreska({
                title: "Upozorenje",
                content: "Za odbijanje surješavanja/praćenja označite samo jedan redak"
            });
            return;
     	}
     	if (radnja == 'ponisti') {
     		naslov = "Poništavanje surješavanja/praćenja";
     		pitaj = "Poništiti";	
     		sIds = [1, 11];
     		pIds = [2, 12];
     		obustava = [11, 12];
     	}
     	else if (radnja == 'prihvati') {
     		naslov = "Prihvaćanje surješavanja/praćenja";	
     		pitaj = "Prihvatiti";	
     		sIds = [1];
     		pIds = [2];
     		obustava = [];
     	}
     	else if (radnja == 'odbij') {
     		naslov = "Odbijanje surješavanja/praćenja";	
     		pitaj = "Odbiti";	
     		sIds = [1];
     		pIds = [2];
     		obustava = [];
     	}
     	if (tablica == 'predmet') naslov = naslov + " predmeta";	
     	else naslov = naslov + " pismena";	
     	
        uk = 0; 
        ukS = 0; 
        ukP = 0; 
		surjPrat = '';
		if (data.length == 1) {
	        if ((data[0].USTROJPRIMA) && (sIds.includes(data[0].SURJESAVATELJ) || pIds.includes(data[0].SURJESAVATELJ))) { 
		        uk += 1;
	        	if (sIds.includes(data[0].SURJESAVATELJ)) surjPrat = ' surješavanje';
	        	else if (pIds.includes(data[0].SURJESAVATELJ)) surjPrat = ' praćenje';  

	        	if ((radnja == 'ponisti') && obustava.includes(data[0].SURJESAVATELJ)) { // obustava samo pojedinačno
		     		naslov = "Obustavljanje surješavanja/praćenja";
		     		pitaj = "Obustaviti";	
		        	} 
	        	}   
	        	if (data[0].KLASA) {
			     	if (tablica == 'predmet') surjPrat = surjPrat + ' predmeta ' +  data[0].PREDMET + ' (Klasa: ' + data[0].KLASA + ') ' + data[0].NAZIV;
			     	else  surjPrat = surjPrat + ' pismena ' +  data[0].PISMENO + ' (Klasa: ' + data[0].KLASA + ', UrBroj: ' + data[0].URUDZBENI + ') ' + data[0].NAZIV;
			     	}
			    else {
			     	if (tablica == 'predmet') surjPrat = surjPrat + ' predmeta ' +  data[0].PREDMET + ' za UJ ' + data[0].USTROJPRIMA + ' ' + data[0].UJPRIMAOZNAKA + ' ' + data[0].UJPRIMANAZIV;
			     	else  surjPrat = surjPrat + ' pismena ' +  data[0].PISMENO + ' za UJ ' + data[0].USTROJPRIMA + ' ' + data[0].UJPRIMAOZNAKA + ' '  + data[0].UJPRIMANAZIV;
			    } 
			}
		else {
			data.forEach(function (item) { 
		        if ((item.USTROJPRIMA) && (sIds.includes(item.SURJESAVATELJ) || pIds.includes(item.SURJESAVATELJ))) { 
			        uk += 1;
	            	if (sIds.includes(item.SURJESAVATELJ)) ukS += 1;
	            	else if (pIds.includes(item.SURJESAVATELJ)) ukP += 1;
	            	}                                                               
			});
			if ((ukS != 0) || (ukP != 0)) {
				if (tablica == 'predmet') {
					if (ukS != 0) surjPrat = surjPrat + ' SURJEŠAVANJE predmeta (ukupno stavaka ' + ukS + ')';
					if (ukP != 0) surjPrat = surjPrat + ' PRAĆENJE predmeta (ukupno stavaka ' + ukP + ')';
				}
				else {
					if (ukS != 0) surjPrat = surjPrat + ' SURJEŠAVANJE pismena (ukupno stavaka ' + ukS + ')';
					if (ukP != 0) surjPrat = surjPrat + ' PRAĆENJE pismena (ukupno stavaka ' + ukP + ')';
				}
	        }			
		}
        if (uk === 0) {
            $.dialogGreska({
                title: "Upozorenje",
                content: "Nema se ništa za " + pitaj.toLowerCase() + '.'
            });
            return;
     	}
    	pitaj = pitaj + surjPrat +'?';
     	
     	if (radnja == 'odbij') {
	     	if (tablica == 'predmet') {
	     		title = naslov + ' ' +  data[0].PREDMET + ' (Klasa: ' + data[0].KLASA + ') ' + data[0].NAZIV; 
	     		link = "predmett/odbijsurjesavanje/" + data[0].PREDMET + "/" + data[0].SURJPREDMETT;
	     	}
	     	else {
	     		title = naslov + ' ' +  data[0].PISMENO + ' (Klasa: ' + data[0].KLASA + ', UrBroj: ' + data[0].URUDZBENI + ') ' + data[0].NAZIV; 
	     		link = "pismenot/odbijsurjesavanje/" + data[0].PISMENO + "/" + data[0].SURJPISMENOT;
	     	}
     		
            $.dialog({
                title: title,
                width: "70%",
                template: kontorouter.getModulPath(link),
                close: function () {
                    grid.kontoGrid.refresh();
                }
            });
     		return;
     	}
     	
        var gotDef = $.Deferred();
        var uspjeh = 0;
        var doneCounter = 0;
        $.dialog({
            content: pitaj,
            title: naslov,
            buttons: {
                "Da": {
                    click: function () {
                    	var that = this;
                    	var krajnjaPoruka = '';
                        try {
					     	if (tablica == 'predmet') {
								data.forEach(function (item) { 
									konto.uz.api.ObradiSurjesavanje(item.SURJPREDMETT, radnja).then(function(rez) {
								        doneCounter += 1;
								        if (rez != ""){
								            krajnjaPoruka += rez + "</br>";
								        }
								        else {																		
								        	uspjeh += 1;
										}
								        if (doneCounter === uk) {
								        	gotDef.resolve();
								        }
							        });					                            
								});
							}
							else {
								data.forEach(function (item) { 
									konto.uz.api.ObradiSurjesavanjePismena(item.SURJPISMENOT, radnja).then(function(rez) {
								        doneCounter += 1;
								        if (rez != ""){
								            krajnjaPoruka += rez + "</br>";
								        }
								        else {																		
								        	uspjeh += 1;
										}
								        if (doneCounter === uk) {
								        	gotDef.resolve();
								        }
							        });					                            
								});
							}
                        }
                        catch (e) { }
						
                        gotDef.then(function(){
                            that.close();
                        	grid.kontoGrid.refresh();
	                        if (doneCounter > 1) krajnjaPoruka = ' Uspješno obrađeno ' + uspjeh + ' od ukupno ' + uk + ' stavaka.<BR>' + krajnjaPoruka;
		                    if (krajnjaPoruka != '') {  
					            $.dialogGreska({
			                        title: "Upozorenje",
			                        content: krajnjaPoruka
		                    	});
		                    }
                        });
                    },
                    isPrimary: true
                },
                "Ne": function () {
                    this.close();
                }
            }
        });

	}		
                
   function dokKnjPrikaziElementeNaPanelu(opcije) {
	   	$(".pnlPojedinacni .elem").addClass("hide");
	   	$(".pnlPojedinacni .elemEnable").prop("disabled", true);
	   	$(".pnlZajednicki .elem").addClass("hide");
	   	$(".pnlZajednicki .elemEnable").prop("disabled", true);
	   	$(".pnlRaspored .elem").addClass("hide");
	   	$(".pnlRaspored .elemEnable").prop("disabled", true);

		if (opcije){
			for (var i = 0, len = opcije.length; i < len; i++) {
			  $(".pnlPojedinacni ." + opcije[i]).removeClass("hide");
			  $(".pnlPojedinacni ." + opcije[i]).prop("disabled", false);
			  $(".pnlZajednicki ." + opcije[i]).removeClass("hide");
			  $(".pnlZajednicki ." + opcije[i]).prop("disabled", false);
			  $(".pnlRaspored ." + opcije[i]).removeClass("hide");
			  $(".pnlRaspored ." + opcije[i]).prop("disabled", false);
			}	
		}					
    }

   function dokKnjPrikaziPanele(opcije, prikaziRasp, prikaziZajednicki) {
		var lsOpcPojedinacni = "UKMPBRFZ";
		var lsOpcZajednicki = "ADPBCN";
		
		$(".pnlZajednicki").addClass("hide");	
	   	if (prikaziZajednicki){
			if (opcije){
				for (var i = 0, len = opcije.length; i < len; i++) {
					if (lsOpcZajednicki.indexOf(opcije[i]) > -1)
			        	$(".pnlZajednicki").removeClass("hide");
						}	
				}					
			}
	   	
        if (prikaziRasp){
			$(".pnlPojedinacni").addClass("hide"); 
       		$(".pnlRaspored").removeClass("hide"); 
        }	
        else {
			if (opcije){
				for (var i = 0, len = opcije.length; i < len; i++) {
					if (lsOpcPojedinacni.indexOf(opcije[i]) > -1)
			        	$(".pnlPojedinacni").removeClass("hide");
						}	
				}					
	        $(".pnlRaspored").addClass("hide"); 
        }
    }

} (konto.uz.utils = {}));